module.exports = __webpack_public_path__ + "assets/img/1818.51cc93ab.svg";